module.exports = __webpack_public_path__ + "img/34.74f067b4.png";